export default {
    "ESCAPE" : 27,
    "ArrowLeft" : 37,
    "ArrowRight" : 39
}